<template>
	<div>
		<div class="lt_bgi">
			<div class="title">
				农事作业信息
			</div>
			<div class="yjbox">
				<div>
					<div style="color: #FF9D5B;">{{msg.record_count}}</div>
					<div>总提交数量</div>
				</div>
				<div>
					<div style="color: #0DDFDF;">{{msg.record_day}}</div>
					<div>今日提交</div>
				</div>

			</div><div class="bjt1">
					<div><img :src="img1" alt="" /></div>
					<div>地块农事TOP排行榜</div>
				</div>
			<div class="conb">
				<div v-for="(item,index) in list" :key="index">
					<div>{{index+1}}</div>
					<div class="w_ms">{{item.plot_name}}</div>
					<div class="w_t">{{item.record_count}}次</div>
				</div>
			</div>
		</div>






	</div>
</template>

<script>
	import {
		top,
		homework
	} from "../../api/home.js";
	import {
		Message
	} from 'element-ui';
	export default {

		data() {
			return {img1: require('../assets/icon.png'),
				msg: {},
				list: [],
			}
		},
		mounted() {
			this.get1()
			this.get2()
		},
		methods: {
			get1() {
				top().then((res) => {

					if (res.code == 0) {
						this.list = res.data
					} else {
						Message.error(res.msg)

					}

				})
			},
			get2() {
				homework().then((res) => {

					if (res.code == 0) {

						this.msg = res.data
						console.log(this.msg)
					} else {
						Message.error(res.msg)

					}

				})
			}
		}
	}
</script>

<style scoped lang="less">
	.lt_bgi {
		width: 28vw;
		height: 50vh;
		background-image: url(/src/assets/rt1.png);
		background-size: 100% 100%;
		background-repeat: no-repeat;
		position: relative;

	}

	.title {

		font-family: Source Han Sans CN;
		font-weight: bolder;
		font-size: 18px;
		color: #FFFFFF;
		font-style: italic;
		background: linear-gradient(0deg, #B5FFDA 0%, #FFFFFF 100%);
		-webkit-background-clip: text;
		-webkit-text-fill-color: transparent;
		position: absolute;
		left: 70px;
		top: 15px
	}

	.yjbox {
		width: 90%;
		position: absolute;
		top: 60px;
		left: 40px;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.yjbox>div {


		width: 49%;

		height: 74px;
		background-image: url(/src/assets/rtt.png);
		background-size: 100% 100%;
		background-repeat: no-repeat;
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
	}

	.yjbox>div>div:nth-of-type(1) {
		font-family: PangMenZhengDao;
		font-weight: 600;
		font-size: 20px;

	}

	.yjbox>div>div:nth-of-type(2) {
		font-family: Source Han Sans CN;
		font-weight: 500;
		font-size: 14px;
		color: #CCEFEC;
	}

	.conb {
		position: absolute;
		top: 180px;
		left: 40px;
		width:100%;
		height:260px;
		overflow: hidden;
		overflow: auto;
		overflow-y: scroll;
		
	}

	.conb>div {
		width: 82%;
		height: 55px;
		display: flex;
		align-items: center;
		
		background-image: url(/src/assets/zhyg.png);
		background-size: 100% 100%;
		background-repeat: no-repeat;
		margin-bottom: 10px;
		padding: 10px 10px 10px 20px;
	}

	.conb>div>div:nth-of-type(1) {
		width: 24px;
		height: 24px;
		background: #11E5C0;
		font-weight: 600;
		border-radius: 50%;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.conb>div>div:nth-of-type(2) {
		width: 300px;
		font-family: Source Han Sans CN;
		font-weight: bold;
		font-size: 16px;
		color: #CCEFEC;
		margin-left:16px ;
	}

	.conb>div>div:nth-of-type(3) {
		font-family: PangMenZhengDao;
		font-weight: bold;
		font-size: 16px;
		color: #11E5C0;
	}	.bjt1 {
		display: flex;
		justify-content: center;
		align-items: center;
		height: 55px;
		position: absolute;
		top: 130px;
		left: 40px;
	}

	.bjt1>div:nth-of-type(1) {
		width: 30px;
		height: 24px
	}

	.bjt1>div>img {
		width: 30px;
		height: 24px
	}

	.bjt1>div {
		text-align: center;
		font-family: Adobe Heiti Std;
		font-weight: normal;
		font-size: 16px;
		color: #11E5C0;
		font-weight: 600;

	}
</style>